import React from 'react';
import LanguageToggle from '../../../../utils/LanguageToggle';
import { fieldErrorMsg, resolveLabel } from '../../../../utils/validationMessages';
import { UsaaValidationLabels } from '../constants/UsaaValidationLabels';
const isAlphaNumeric = (input) => {
    return input.match(/^[a-z0-9]+$/i) !== null;
};
const isNumeric = (input) => {
    return input.match(/^[0-9]+$/i) !== null;
};
// export const validateRequestor = (input: any, label: FieldLabelInput) => {
//   if (!input) {
//     return fieldRequiredMsg(label);
//   }
//   return undefined;
// };
// export const validateNotEmpty = (input: any, label: FieldLabelInput) => {
//   if (!input) {
//     return fieldRequiredMsg(label);
//   }
//   return undefined;
// };
export const validateEmpID = (input, label) => {
    if (!input) {
        return <LanguageToggle en="Please enter a 5 character Employer ID" es="Por favor ingrese una ID de empleador de 5 caracteres."/>;
    }
    else if (input.length > 5) {
        return fieldErrorMsg(label, 'is too long - please enter exactly 5 characters.', 'es demasiado largo - ingrese exactamente 5 caracteres.');
    }
    else if (input.length < 5) {
        return fieldErrorMsg(label, 'is too short - please enter exactly 5 characters.', 'es demasiado corto - ingrese exactamente 5 caracteres.');
    }
    else if (!isAlphaNumeric(input)) {
        return fieldErrorMsg(label, 'must be alphanumeric.', 'debe ser alfanumérico.');
    }
    return undefined;
};
export const validateSelectGeneric = (input, label) => {
    if (!input) {
        return fieldErrorMsg(label, ': Please make a selection.', ': Por favor haga una selección.');
    }
    return undefined;
};
export const validateDate = (input, label) => {
    if (input) {
        if (input === '0') {
            return fieldErrorMsg(label, 'must be between 1 and 31.', 'debe estar entre 1 y 31.');
        }
        else if (input.length > 2) {
            return fieldErrorMsg(label, 'is too long.', 'es demasiado larga.');
        }
        else if (!isNumeric(input)) {
            return fieldErrorMsg(label, 'must be numeric.', 'debe ser numérica.');
        }
    }
    return undefined;
};
export const validateFields = (values) => {
    return {
        requesterType: validateSelectGeneric(values.requesterType, UsaaValidationLabels.requesterType),
        employeeId: validateEmpID(values.employeeId, UsaaValidationLabels.employeeId),
        birthMonth: validateSelectGeneric(values.birthMonth, UsaaValidationLabels.birthMonth),
        birthDay: validateDate(values.birthDay, UsaaValidationLabels.birthDay),
    };
};
export const validateTwoTimes = (expectedEarlierTimeValue, expectedEarlierTimeLabel, expectedLaterTimeValue, expectedLaterTimeLabel) => {
    if (expectedEarlierTimeValue >= expectedLaterTimeValue) {
        const earlier = resolveLabel(expectedEarlierTimeLabel);
        const later = resolveLabel(expectedLaterTimeLabel);
        return (<LanguageToggle en={`${later.en} cannot be equal to or earlier than ${earlier.en}. Please correct ${later.en} or ${earlier.en}.`} es={`${later.es} no puede ser igual o anterior a ${earlier.es}. Por favor corrija ${later.es} o ${earlier.es}.`}/>);
    }
    return undefined;
};
export const timeOffFormValidate = (values) => {
    if (values.estimatedArrival || values.regularEndTime || values.estimatedReturn) {
        return {
            estimatedArrival: validateTwoTimes(values.normalStartTime, UsaaValidationLabels.normalStartTime, values.estimatedArrival, UsaaValidationLabels.estimatedArrival),
            regularEndTime: validateTwoTimes(values.departureTime, UsaaValidationLabels.departureTime, values.regularEndTime, UsaaValidationLabels.regularEndTime),
            estimatedReturn: validateTwoTimes(values.departureTime, UsaaValidationLabels.departureTime, values.estimatedReturn, UsaaValidationLabels.estimatedReturn),
        };
    }
    return undefined;
};
export const clearAndRelyOnFormForComposite = (value, values) => {
    return undefined;
};
